import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Message from 'components/text/Message/Message'
import Image from 'components/_new/ui/Image/Image'
import { MenuLink } from 'components/_new/ui/Menu'

import s from './Card.scss'
import messages from './messages'


class HeaderSubNavDropdownCard extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]).isRequired,
    image: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.object,
    ]),
    imageContainerClassName: PropTypes.string,
    to: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    small: PropTypes.bool,
    badge: PropTypes.string,
    transparent: PropTypes.bool,
    dataTestId: PropTypes.string,
  }

  render() {
    const {
      className, title, image, to, small, transparent, badge, imageContainerClassName,
      dataTestId, onClick, index, _ref, state, setState,
    } = this.props

    const rootClassName = cx(s.root, className, {
      [s.small]: small,
    })

    const premiumBadgeClassName = cx(s.badge, {
      [s.gold]: badge === 'gold',
    })

    const imageProps = typeof image === 'object' ? image : { src: image, x2: true, w: small ? 200 : 420 }

    return (
      <div className={rootClassName}>
        <MenuLink
          className={s.link}
          to={to}
          customColor
          onClick={onClick}
          {...{ index, _ref, state, setState }}
        >
          <div className={s.header}>
            <Message tag="div" className={s.title} text={title} dataTestId={dataTestId} />
            {
              Boolean(badge) && (
                <Message tag="div" className={premiumBadgeClassName} text={messages.premium} />
              )
            }
          </div>
          <div className={s.body}>
            <div className={cx(s.imageContainer, imageContainerClassName)}>
              <Image
                className={s.image}
                {...imageProps}
              />
              <div className={cx(s.imageOverlay, { [s.imageOverlayTransparent]: transparent })} />
            </div>
          </div>
        </MenuLink>
      </div>
    )
  }
}

export default HeaderSubNavDropdownCard
